<template>
  <div>
    <b-row>
      <b-col md="6" class="my-1">
        <h3 class="text-themecolor">{{$t('sidebar.klantrelaties')}}</h3>
      </b-col>
      <b-col md="6" class="my-1">
        <div class="pull-right">
          <b-button variant="themecolor" size="sm" @click="goTo('create')" class="mr-1">
            <i class="fa fa-plus" aria-hidden="true"></i> {{$t('buttons.toevoegen')}}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <!-- User Interface controls -->
            <b-row>
              <b-col md="12" class="my-1">
                <b-form-group class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- User Interface controls -->
            <!-- Main table element -->
            <b-row>
              <b-col md="12">
                <b-table show-empty
                        stacked="md"
                        :empty-text="getEmptyText(count)"
                        :busy="count == -1"
                        class="table-hover"
                        :items="customerRelations"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        @filtered="onFiltered"
                        @row-clicked="onRowClicked">
                        <template v-slot:cell(street)="data">{{data.item.address.street}}</template>
                        <template v-slot:cell(zipCode)="data">{{data.item.address.zipCode}}</template>
                        <template v-slot:cell(emailAddress)="data">{{data.value.address != '' ? data.value.address : 'Onbekend' }}</template>
                        <template v-slot:cell(phoneNumber)="data">{{data.value.number != '' ? data.value.number : 'Onbekend' }}</template>
                        <template v-slot:table-busy>
                          <PreLoader/>
                        </template>
                </b-table>
              </b-col>
            </b-row>
            <!-- Main table element -->

            <!-- Pagination controls -->
            <b-row>
              <b-col md="12" lg="5" >
                <b-form-group label-cols :label="$t('datatables.perpagina')">
                  <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
              </b-col>
              <b-col md="12" lg="7">
                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- Pagination controls -->
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader  from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
  name: 'customer-relations-index',
  components: {PreLoader},
  data () {
    return {
      currentPage: 1,
      perPage: 50,
      pageOptions: [ 50, 100, 200 ],
      filter: null,
      count: -1,
    }
  },
  computed: {
    fields() {
        return [
          { key: 'tag', label: this.$i18n.t('datatables.relatienr'), sortable: true },
          { key: 'name', label: this.$i18n.t('datatables.naam'), sortable: true },
          { key: 'street', label: this.$i18n.t('datatables.straat'), sortable: true },
          { key: 'zipCode', label: this.$i18n.t('datatables.postcode'), sortable: true },
          { key: 'emailAddress', label: this.$i18n.t('datatables.emailadres'), sortable: true },
          { key: 'phoneNumber', label: this.$i18n.t('datatables.telefoonnummer'), sortable: true}
        ]
    },
    ...mapGetters ('core', ['customerRelations']),
    sortOptions () {
      return this.fields.filter(f => f.sortable).map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
    ...mapActions('core',['all']),
    onFiltered (filteredItems) {
      this.count = filteredItems.length;
      this.currentPage = 1
    },
    onRowClicked(item) {
      this.$router.push({ name: 'customer-relations:detail', params: { customerRelationId: item.id } });
    },
    goTo(name) {
      this.$router.push({ name: `customer-relations:${name}` });
    },
    getEmptyText,
  },
  watch: {
    customerRelations: function(value) {
      this.count = value.length;
    }
  },
  created() {
    var vm = this;
    vm.all({
      resource: 'customer-relations'
    })
    .then((data) => {
      vm.count = data.result.length;
    });
  }
}
</script>